// flow components
export { ConsumptionDetails } from './ConsumptionDetails/ConsumptionDetails';
export { DetailsIcon } from './DetailsIcon/DetailsIcon';
export { FlowRadioGroup } from './FlowRadioGroup/FlowRadioGroup';
export { Header } from './Header/Header';
export { StepHeader, STEP_TITLE_ID, getRadioGroupNameProps } from './StepHeader/StepHeader';
export { Iconlist } from './Iconlist/Iconlist';
export { Layout } from './Layout/Layout';
export { NavigationBar } from './NavigationBar/NavigationBar';
export { NavigationCloseButton } from './NavigationCloseButton/NavigationCloseButton';
export { NavigationHelpButton } from './NavigationHelpButton/NavigationHelpButton';
export { NextButton } from './NextButton/NextButton';
export {
  ContactDetailsEmailField,
  ContactDetailsFormFields,
  ContactDetailsOptIn,
  ContactDetailsPhoneField,
  DUTCH_PHONE_PATTERN,
  LeadContactDetailsShell,
  SALESFORCE_LEAD_RECORD_TYPE_ID,
  createSalesforceLeadContact,
  useContactDetailsForm,
} from './ContactDetailsFields/ContactDetailsFields';
export { SalesforceLeadContactStep } from './ContactDetailsFields/SalesforceLeadContactStep';
export type { ContactDetailsFormValues, ContactDetailsTextualData } from './ContactDetailsFields/ContactDetailsFields';
export {
  PersonalDetailsBirthdate,
  PersonalDetailsSalutation,
  PersonalDetailsTextField,
} from './PersonalDetailsFields/PersonalDetailsFields';
export { PersonalDetailsFormFields } from './PersonalDetailsFields/PersonalDetailsFormFields';
export type { PersonalDetailsContent } from './PersonalDetailsFields/PersonalDetailsFormFields';
export {
  formatPersonalDetailsBirthdate,
  personalDetailsBirthdateSchema,
  personalDetailsNameFields,
} from './PersonalDetailsFields/personalDetailsSchema';
export { Overview } from './Overview/Overview';
export { CancellationOverview } from './CancellationOverview/CancellationOverview';
export { Price, SMEPrice } from './Price/Price';
export { PriceDetails } from './PriceDetails/PriceDetails';
export { Ribbon } from './Ribbon/Ribbon';
export { FlowSpinner } from './FlowSpinner/FlowSpinner';
export { AuthenticationGuard } from './AuthenticationGuard/AuthenticationGuard';
export { CallSupport } from './CallSupport/CallSupport';

// flow step components that are shared between multiple step components
export { ChoiceStepFooter } from '../stepsSharedComponents/ChoiceStepFooter/ChoiceStepFooter';
export { FlowError } from '../stepsSharedComponents/Error/Error';
export { LoginCard } from '../stepsSharedComponents/LoginCard/LoginCard';
export { LogInStepView } from '../stepsSharedComponents/LogInStepView/LogInStepView';
export { Navigation } from '../stepsSharedComponents/Navigation/Navigation';
export type { Props as NavigationProps } from '../stepsSharedComponents/Navigation/Navigation';

// multi-label common flow step components
export { GenericCheckboxChoiceStep } from '../steps/GenericCheckboxChoiceStep/GenericCheckboxChoiceStep';
export { GenericChoiceStep } from '../steps/GenericChoiceStep/GenericChoiceStep';
export { GenericRadioChoiceStep } from '../steps/GenericRadioChoiceStep/GenericRadioChoiceStep';
export { AccountSelectStep } from '../steps/AccountSelectStep/AccountSelectStep';
export { AddressStep } from '../steps/AddressStep/AddressStep';
export { AddressFinderAvailabilityStep } from '../steps/AddressFinderAvailabilityStep/AddressFinderAvailabilityStep';
export { CancellationReasonStep } from '../steps/CancellationReasonStep/CancellationReasonStep';
export { SmartThermostatCancellationReasonStep } from '../steps/SmartThermostatCancellationReasonStep/SmartThermostatCancellationReasonStep';
export type { SmartThermostatCancellationReasonFlowContext } from '../steps/SmartThermostatCancellationReasonStep/SmartThermostatCancellationReasonStep';

// presentational "offer/overview page" shells, shared by flows with a similar shape (dongle, bundle).
// These hold no data-fetching or flow-context logic — the flow keeps that and supplies content as props/children.
export { ProductOfferStep } from '../steps/ProductOfferStep/ProductOfferStep';
export type {
  ProductOfferStepProps,
  ProductOfferStepItem,
  ProductOfferStepNotification,
} from '../steps/ProductOfferStep/ProductOfferStep';
export { OfferItemCard } from '../steps/ProductOfferStep/OfferItemCard';
export type { OfferItemCardProps, OfferPriceRow } from '../steps/ProductOfferStep/OfferItemCard';
export { ProductSummaryStep } from '../steps/ProductSummaryStep/ProductSummaryStep';
export type {
  ProductSummaryStepProps,
  ProductSummaryStepOverviewSection,
  ProductSummaryStepOverviewProductItem,
  ProductSummaryStepTermsAndConditions,
  ProductSummaryStepNotification,
} from '../steps/ProductSummaryStep/ProductSummaryStep';
export { EnecoInHuisLeadFlowsPersonalDetailsStep } from '../steps/EnecoInHuisLeadFlowsPersonalDetailsStep/EnecoInHuisLeadFlowsPersonalDetailsStep';
